import React from 'react';

import {
  getActivityOrNotificationDescription,
  VERB_ICONS,
} from 'app/activity/shared-utils';
import {getNotificationsContentTypeMapSelector} from 'app/notifly/selectors';
import {gt} from 'app/utils/i18n';
import {markAsSafe} from 'app/utils/strings';

import type {NotificationType} from './types';
import type {ContentType} from 'sweet-types';

export const getNotificationDescription = (notification: NotificationType) => {
  if (notification.verb === 'broadcast') {
    const author = notification.content.args.actors;
    const formattedMessage = (
      <div
        className="broadcast-message-content"
        dangerouslySetInnerHTML={markAsSafe(
          notification.additional_data.message
        )}
      />
    );
    return (
      <span>
        {formattedMessage}
        <span className="broadcast-message-signature">
          {gt('SweetProcess Team (%(author)s)', {
            author,
          })}
        </span>
      </span>
    );
  }

  return getActivityOrNotificationDescription(notification);
};

export {VERB_ICONS};

export const getNotificationsByContentType = (
  state: any,
  ct: ContentType,
  ids: Array<number | string>
) =>
  ids.length === 0
    ? {}
    : getNotificationsContentTypeMapSelector(state, ct, ids);
